import { render } from "./AppAlert.vue?vue&type=template&id=56de7b26"
import script from "./AppAlert.vue?vue&type=script&lang=js"
export * from "./AppAlert.vue?vue&type=script&lang=js"

import "./AppAlert.vue?vue&type=style&index=0&id=56de7b26&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__